// get body padding from fixed header height
function setHeaderHeight() {
	let header = document.querySelector('.js__pageheader');
	let body = document.querySelector('body');

	body.style.paddingTop = `${header.offsetHeight}px`;
}

function initHeaderHeightCalculation() {

	// fire function when browser window is resized
	window.addEventListener('resize', setHeaderHeight);

// and fires the function when DOM is ready
	document.addEventListener("DOMContentLoaded", setHeaderHeight);

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		window.borlabsCookieOptInGoogleAnalytics = true;
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'registrationComplete',
		});
	}, false );

}

export default initHeaderHeightCalculation;
